<template>
    <span v-if="isValidDeal || ticket.discount_text !== '' || (hasTours && !mobile)" :class="['tooltips', { mobile }]">
        <div v-if="ticket.discount_text !== ''" class="model-tooltip" @click="toggleTipModal()">
            <i class="fa fa-commenting"></i>
            <div :class="['tip', position, {opened: this.tip}]">
                <i v-if="mobile" class="fa fa-times"></i>
                <div v-html="ticket.discount_text"></div>
            </div>
        </div>

        <div v-if="isValidDeal" class="model-tooltip model-tooltip--deal" @click="toggleDealModal()">
            <i :class="'fa ' + icons[ticket.deal]"></i>
            <div :class="['tip', position, {opened: this.deal}]">
                <i v-if="mobile" class="fa fa-times"></i>
                <strong v-html="ticket.deal_title"></strong>
                <div v-html="ticket.deal_text"></div>
            </div>
        </div>

        <div v-if="hasTours && !mobile" class="model-tooltip model-tooltip--tour" @click="toggleTourModal()">
            <i class="fa fa-gift"></i>
            <div :class="['tip', position, {opened: this.tour}]">
                <i v-if="mobile" class="fa fa-times"></i>
                <strong v-html="tourTitle"></strong>
                <div v-html="tourShortDescription"></div>
            </div>
        </div>
    </span>
</template>

<style lang="scss" scoped>
    $icon-dimensions: 20px;

    label.active,
    td:hover label {
        .model-tooltip .fa:not(.koko-deal) {
            background: transparent;
            color: #FFF;
            border: 1px solid #FFF;
            font-size: 10px;
            line-height: 1.7em;
        }

        .model-tooltip .koko-deal {
            filter: none;
        }
    }

    .tooltips {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: 100%;

        .fa-times {
            float: right;
            margin-left: 4px;
            margin-bottom: 4px;
        }

        &.mobile {
            justify-content: center;
            align-items: center;
            width: auto;

            .model-tooltip .fa,
            .english-tooltip .fa {
                text-align: center;
            }
        }
    }

    .tooltips:not(.mobile) {
        .model-tooltip:hover .tip,
        .english-tooltip:hover .tip {
            display: block;
        }
    }

    .model-tooltip,
    .english-tooltip {
        display: inline;
        position: relative;
        margin-left: 5px;
        color: white;
        line-height: 0;

        .fa {
            background: #FFF;
            border-radius: 50%;
            font-size: 15px;
            width: $icon-dimensions;
            height: $icon-dimensions;
            line-height: 1.3em;

            &.fa-bolt {
                color: var(--color-yellow);
            }

            &.fa-usd {
                background: var(--color-orange);
                color: #FFF;
                font-size: 12px;
                line-height: 1.7em;
            }

            &.fa-commenting {
                color: var(--color-blue);
            }

            &.fa-calendar-check-o {
                color: var(--color-purple-dark);
            }

            &.fa-star {
                color: var(--color-pink);
            }

            &.fa-exclamation {
                color: var(--color-red);
            }

            &.koko-deal {
                background: url('/images/tickets/koko-deal.svg');
                filter: grayscale(100%);
            }
        }

        .tip {
            display: none;
            margin: 0 auto;
            position: absolute;
            background: var(--color-gray-light);
            color: var(--color-gray-dark-content);
            width: 250px;
            height: auto;
            padding: 15px;
            width: 200px;
            text-align: left;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.3em;
            border-radius: 5px;
            bottom: 30px;
            border: 1px solid #CFD1D7;
            left: 50%;
            transform: translate(-50%);
            z-index: var(--zindex-header);

            &.opened {
                display: block;
            }

            &.soft-right {
                left: auto;
                right: -10px;
                transform: none;

                &:before,
                &:after {
                    margin-right: 10px;
                }
            }

            b,
            strong {
                display: block;
                font-weight: bold;
            }

            &:before,
            &:after {
                content: '';
                display: inline-block;
                margin: 0 auto;
                vertical-align: middle;
                width: 0;
                height: 0;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                position: absolute;
                left: 0;
                right: 0;
            }

            &:before {
                border-top: 8px solid #CFD1D7;
                bottom: -8px;
            }

            &:after {
                border-top: 8px solid var(--color-gray-light);
                bottom: -7px;
            }
        }
    }

    .model-tooltip.model-tooltip--tour {
        color: #000000;

        &:hover {
            color: #ffffff;
        }
    }
</style>

<script>
    export default {
        props: {
            position: String,
            mobile: {
                type: Boolean,
                required: true,
            },
            ticket: {
                type: Object,
                required: true,
            },
            icons: {
                type: Array,
                required: true,
            },
            config: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                tip: false,
                deal: false,
                tour: false
            }
        },

        computed: {
            isValidDeal() {
                return this.config.allow_deals && this.ticket.deal && this.ticket.deal_title !== ''
            },
            tours() {
                return this.ticket.includes.filter(include => include.type === 'Tour')
            },
            hasTours() {
                return this.tours.length > 0
            },
            tourTitle() {
                return this.hasTours ? this.tours[0].title : ''
            },
            tourShortDescription() {
                return this.hasTours ? this.tours[0].short_description : ''
            }
        },

        methods: {
            toggleTipModal() {
                this.tip = !this.tip
            },

            toggleDealModal() {
                this.deal = !this.deal
            },

            toggleTourModal() {
                this.tour = !this.tour
            }
        }
    }
</script>
